import React, { useState, useEffect } from "react";
import { Container, Grid, Pagination } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import SearchComponent from "../../components/Custom/CustomSearch";
import ListGenericCard from "../../components/Custom/ListGenericCard";
import { useNavigate } from "react-router-dom";

export default function MyBorrowersList() {
  const [proposals, setProposals] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const pageSize = 8;
  const navigate = useNavigate();

  const fetchBorrowerList = async (searchQuery) => {
    try {
      const params = { search: searchQuery };
      const response = await api.get("/lending/get-loan-request-list/", {
        params: params,
      });
      setProposals(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Borrower list:", error);
      setLoading(false);
    }
  };

  const fetchData = (page, pageSize) => {
    const startIndex = (page - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize, proposals.length);
    return proposals.slice(startIndex, endIndex);
  };

  const handleSearch = (value) => {
    setSearchQuery(value);
    setPage(1); // Reset page to 1 when performing a new search
  };

  const handleCardClick = (userId, loanId) => {
    navigate(`/lender/view-fpo/${userId}?loanId=${loanId}`);
  };

  useEffect(() => {
    fetchBorrowerList(searchQuery);
  }, [searchQuery]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container maxWidth="xs">
          <Grid container>
            <CustomTitle>{t("My Borrowers")}</CustomTitle>
            <SearchComponent
              onSearch={handleSearch}
              t={t}
              roundIcon
              placeholder={t("Search borrowers...")}
            />
            {proposals && proposals.length !== 0 && (
              <div
                style={{
                  width: "100%",
                  height: "77vh",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    height: "93%",
                    width: "100%",
                    overflowY: "scroll",
                  }}
                >
                  {fetchData(page, pageSize).map((proposal, index) => (
                    <div style={{ width: "99%" }} key={index}>
                      <ListGenericCard
                        key={proposal.id}
                        title={`${proposal?.submit_user?.user?.first_name} ${proposal?.submit_user?.user?.last_name}`}
                        subtitle={[
                          `${proposal.loan_amount}`,
                          `${proposal.loan_tenure_months}`,
                          `${proposal.lender_status}`,
                        ]}
                        onClick={() =>
                          handleCardClick(
                            proposal?.submit_user?.id,
                            proposal.loan_id
                          )
                        }
                      />
                    </div>
                  ))}
                </div>

                <Pagination
                  style={{ margin: "10px 0" }}
                  count={Math.ceil(proposals.length / pageSize)} // Total number of pages
                  page={page}
                  onChange={handlePageChange}
                  sx={{
                    "& .Mui-selected": {
                      color: "green",
                      borderBottom: "1px solid green",
                      borderRadius: 0,
                      backgroundColor: "transparent",
                    },
                    "& .MuiPaginationItem-icon": {
                      color: "green",
                      fontSize: "30px",
                    },
                  }}
                />
              </div>
            )}
          </Grid>
        </Container>
      </LoaderContainer>
    </>
  );
}
